export default __webpack_public_path__ + "743fd23712bac63f3029176dd36dc1cf.png";